import React from "react";
import { useChartOfAccountsQuery } from "@api/accountingReports.api";
import { BaseFilterProps } from "../../lib";
import { CoaAccountList } from "../CoaAccountFilter/CoaAccountList";

export const SplitAccountFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { data: chartOfAccounts } = useChartOfAccountsQuery();

    return (
        <CoaAccountList
            accounts={chartOfAccounts?.accounts}
            groups={chartOfAccounts?.groups}
            entityIds={filters.entityIds}
            selectedIds={filters.splitCoaAccounts}
            onSelectedIdsChange={(splitCoaAccounts) =>
                onChange({ splitCoaAccounts })
            }
            onClearAll={() => onChange({ splitCoaAccounts: undefined })}
        />
    );
};
